import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app.component";
import {appConfig} from "./app/app.config";
import { defineCustomElements } from '@infragistics/igniteui-dockmanager/loader';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
// igniteui-dockmanager (Stencil 1.x)
defineCustomElements();
